import { PRODUCTS } from "../../types/ProductType";

import axios from "axios";

export const getAllProductAction = (data) => {
	return {
		type: PRODUCTS,
		payload: data,
	};
};

// export const loadProduct = ({ page, limit, status }) => {
// 	//dispatching with an call back function and returning that
// 	return async (dispatch) => {
// 		try {
// 			const { data } = await axios.get(
// 				`product?status=${status}&page=${page}&count=${limit}`
// 			);
// 			//dispatching data
// 			// console.log(data)
// 			dispatch(getAllProductAction(data));
// 		} catch (error) {
// 			console.log(error.message);
// 		}
// 	};
// };

export const loadProduct = ({
	status,
	viewMode = "stock",
	onlyLedgerStock,
	sort_by,
	sort_order,
}) => {
	return async (dispatch) => {
	  try {
		let url = `product?status=${status}&query=all&view_mode=${viewMode}`;
		if (onlyLedgerStock === true || onlyLedgerStock === "true") {
			url += `&only_ledger_stock=1`;
		}
		if (sort_by) url += `&sort_by=${encodeURIComponent(sort_by)}`;
		if (sort_order) url += `&sort_order=${encodeURIComponent(sort_order)}`;
		const { data } = await axios.get(url);
		const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
		dispatch(getAllProductAction(list));
	  } catch (error) {
		console.log(error.message);
	  }
	};
  };
